export const mecklenburgVorpommern = {
  slug: "mecklenburg-vorpommern",
  name: "Mecklenburg-Vorpommern",
  hero: {
    eyebrow: "Bundesland-Übersicht",
    title: "Erdwärme in Mecklenburg-Vorpommern",
    subtitle:
      "Kurze, praxisnahe Übersicht zu Förderung, Datenlage, Kartenportal und typischen Standortthemen – als Einstieg vor Planung und Angeboten.",
    infoBox:
      "Hinweis: Mecklenburg-Vorpommern stellt für die oberflächennahe Geothermie Leitfaden, Anzeigeformulare, Übersichtskarten und ein Kartenportal für die erste Standortprüfung bereit.",
  },
  seo: {
    title:
      "Erdwärme in Mecklenburg-Vorpommern – Förderung, Daten & Kartenportal | Erdwärme-Experten",
    description:
      "Kurzübersicht für Erdwärme in Mecklenburg-Vorpommern: KfW-Förderung, Leitfaden, Kartenportal Umwelt MV, Übersichtskarten zur Wärmeleitfähigkeit und Hinweise zur Vorprüfung.",
    canonical: "https://www.erdwaerme-experten.de/bundeslaender/mecklenburg-vorpommern",
  },

  facts: [
    {
      title: "Förderung (Bund)",
      icon: "BadgeCheck",
      color: "from-rose-600 to-rose-500",
      bullets: [
        "Heizungstausch-Zuschuss über KfW Programm 458 für Bestandsgebäude",
        "30 % Grundförderung; persönliche Boni können die Quote erhöhen",
        "Maximal 80 %; kein separater Effizienzbonus für Erdwärme",
      ],
      note:
        "Förderstand 21.07.2026. Die tatsächliche Förderfähigkeit hängt von Gebäude, Eigentum, Einkommen und weiteren Voraussetzungen ab.",
      link: {
        label: "KfW 458 (offiziell)",
        href: "https://www.kfw.de/inlandsfoerderung/Privatpersonen/Bestehende-Immobilie/F%C3%B6rderprodukte/Heizungsf%C3%B6rderung-f%C3%BCr-Privatpersonen-Wohngeb%C3%A4ude-%28458%29/",
      },
    },
    {
      title: "Leitfaden & Verfahren",
      icon: "ShieldCheck",
      color: "from-slate-700 to-slate-600",
      bullets: [
        "Fachliche und rechtliche Informationen sind im Leitfaden Erdwärmesonden und Erdwärmekollektoren M-V zusammengestellt",
        "Hinweise zum Verfahrensablauf bei den zuständigen unteren Wasserbehörden sind verfügbar",
        "Anzeigeformulare werden zentral bereitgestellt",
      ],
      note:
        "Das ist für die Vorprüfung besonders hilfreich, weil Verfahren und Unterlagen vergleichsweise übersichtlich gebündelt sind.",
      link: {
        label: "LUNG – Oberflächennahe Geothermie in M-V",
        href: "https://www.lung.mv-regierung.de/fachinformationen/geologie/fachinformationssysteme/tieferer-untergrund-geothermie/oberflaechennahe-geothermie-mv/",
      },
    },
    {
      title: "Datenlage & Kartenportal",
      icon: "Layers",
      color: "from-indigo-700 to-indigo-600",
      bullets: [
        "Für die erste Standortprüfung kann das Kartenportal Umwelt M-V genutzt werden",
        "Dort werden auch Übersichtskarten zur mittleren spezifischen Wärmeleitfähigkeit und zu Restriktionsflächen genannt",
        "Standortrelevante Angaben wie geologisches Vorprofil oder Grundwasserflurabstand können für das Verfahren wichtig werden",
      ],
      note:
        "Mecklenburg-Vorpommern gehört für deine Vorprüfung zu den Bundesländern mit guter Datengrundlage.",
      link: {
        label: "Kartenportal / Oberflächennahe Geothermie M-V",
        href: "https://www.lung.mv-regierung.de/fachinformationen/geologie/fachinformationssysteme/tieferer-untergrund-geothermie/oberflaechennahe-geothermie-mv/",
      },
    },
    {
      title: "Untergrund & regionale Besonderheiten",
      icon: "Droplets",
      color: "from-emerald-700 to-emerald-600",
      bullets: [
        "Für die Standortprüfung sind geologische Informationen am Standort ausdrücklich wichtig",
        "In M-V spielen Lockergesteine, Grundwasserverhältnisse und lokale Restriktionsflächen oft eine große Rolle",
        "Je nach Standort kann die Eignung für Sonde oder Kollektor unterschiedlich ausfallen",
      ],
      note:
        "Gerade im norddeutschen Lockergesteinsraum lohnt sich eine standortbezogene Vorprüfung besonders.",
      link: {
        label: "Regierungsportal M-V – Erdwärmenutzung",
        href: "https://www.regierung-mv.de/Landesregierung/lm/Umwelt/geologie/erdwaermenutzung/",
      },
    },
  ],

  dataCards: [
    {
      title: "Welche Daten sind relevant?",
      icon: "Layers",
      desc:
        "Wärmeleitfähigkeit, geologisches Vorprofil, Grundwasserflurabstand und Restriktionsflächen sind zentrale Bausteine der Vorprüfung.",
    },
    {
      title: "Was ist häufig der Engpass?",
      icon: "ThermometerSun",
      desc:
        "Weniger die grundsätzliche Idee, sondern eher die standortabhängige Kombination aus Geologie, Grundwasser und wasserrechtlicher Einordnung.",
    },
    {
      title: "Was macht euer GeoReport konkret?",
      icon: "FileText",
      desc:
        "Zusammenführung der verfügbaren Standortdaten mit einer ersten technischen Einschätzung, Dimensionierung und grober Kosten-/Förderlogik.",
    },
  ],

  faq: [
    {
      q: "Gibt es in Mecklenburg-Vorpommern einen guten Einstieg für die Vorprüfung?",
      a: "Ja. Das LUNG stellt für die oberflächennahe Geothermie einen Leitfaden, Anzeigeformulare, Übersichtskarten und Hinweise zum Kartenportal Umwelt M-V bereit.",
      links: [
        {
          label: "LUNG – Oberflächennahe Geothermie in M-V",
          href: "https://www.lung.mv-regierung.de/fachinformationen/geologie/fachinformationssysteme/tieferer-untergrund-geothermie/oberflaechennahe-geothermie-mv/",
        },
      ],
    },
    {
      q: "Welche Daten sind für die erste Einschätzung besonders wichtig?",
      a: "Für die erste Prüfung nennt Mecklenburg-Vorpommern insbesondere geologische Standortinformationen. Je nach Fall können zusätzlich Angaben zum geologischen Vorprofil oder zum Grundwasserflurabstand erforderlich sein.",
      links: [
        {
          label: "Regierungsportal M-V – Erdwärmenutzung",
          href: "https://www.regierung-mv.de/Landesregierung/lm/Umwelt/geologie/erdwaermenutzung/",
        },
      ],
    },
    {
      q: "Ist Mecklenburg-Vorpommern für eine datenbasierte Vorprüfung geeignet?",
      a: "Ja, im Vergleich zu einigen anderen Bundesländern ist die Datengrundlage für die oberflächennahe Geothermie in M-V gut nutzbar, weil Leitfaden, Kartenportal und Übersichtskarten zentral bereitstehen.",
      links: [
        {
          label: "LUNG – Oberflächennahe Geothermie in M-V",
          href: "https://www.lung.mv-regierung.de/fachinformationen/geologie/fachinformationssysteme/tieferer-untergrund-geothermie/oberflaechennahe-geothermie-mv/",
        },
      ],
    },
  ],

  cta: {
    title: "Mecklenburg-Vorpommern-Standort prüfen (datenbasiert)",
    text:
      "Du bekommst eine standortbezogene Vorabschätzung: verfügbare Untergrunddaten, erste Dimensionierung, Kosten-/Förderlogik und Hinweise zu typischen Genehmigungsthemen – als Grundlage für die nächsten Schritte.",
    primary: {
      label: "Jetzt Standort-Report erstellen",
      href: "/report",
      title: "Erdwärme Standort-Report für Mecklenburg-Vorpommern erstellen",
    },
    secondary: { label: "Erst Grundlagen ansehen", href: "/flache-geothermie" },
    footnote:
      "Tipp: In Mecklenburg-Vorpommern lohnt sich ein früher Blick in das Kartenportal besonders, weil dort schon viele standortrelevante Hinweise zusammenlaufen.",
  },
};